import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { ITimeGroup } from 'app/models/filter-form.models';
import { convertTimeNumberToString } from 'app/utils/date.utils';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';

@Component({
  selector: 'app-all-data-time-filter',
  templateUrl: './time-filter.component.html',
  styleUrls: ['./time-filter.component.scss'],
  imports: [MatFormField, MatSelect, FormsModule, NgFor, MatOption],
})
export class AllDataTimeFilterComponent implements OnInit {
  timeGroup!: ITimeGroup;

  minutes = Array.from(Array(60).keys()).map((min) => convertTimeNumberToString(min));

  hours = Array.from(Array(24).keys()).map((hr) => convertTimeNumberToString(hr));

  @Output() timeFilterChange = new EventEmitter<ITimeGroup>();

  @Input() set data(value: ITimeGroup | undefined) {
    if (!value) {
      this.clearTimeGroup();
      return;
    }

    this.timeGroup = value;
  }

  @Input() onClear!: Subject<void>;

  ngOnInit(): void {
    this.onClear.subscribe(() => {
      this.clearTimeGroup();
    });
  }

  onFromHourChange() {
    if (!this.timeGroup.minutesFrom) this.timeGroup.minutesFrom = '00';

    this.onTimeChange();
  }

  onFromMinuteChange() {
    if (!this.timeGroup.hoursFrom && this.timeGroup.minutesFrom) this.timeGroup.hoursFrom = '00';

    this.timeFilterChange.emit({
      hoursFrom: this.timeGroup.hoursFrom,
      minutesFrom: this.timeGroup.minutesFrom,
      hoursTo: this.timeGroup.hoursTo,
      minutesTo: this.timeGroup.minutesTo,
    });

    this.onTimeChange();
  }

  onToHourChange(value: string) {
    if (this.timeGroup.minutesFrom && this.timeGroup.hoursFrom === value) {
      this.timeGroup.minutesTo = convertTimeNumberToString(+this.timeGroup.minutesFrom + 1);

      return;
    }

    this.timeGroup.minutesTo = '00';
    this.onTimeChange();
  }

  onToMinuteChange() {
    if (!this.timeGroup.hoursTo && this.timeGroup.minutesTo) this.timeGroup.hoursTo = '00';

    this.onTimeChange();
  }

  private onTimeChange() {
    this.timeFilterChange.emit({
      hoursFrom: this.timeGroup.hoursFrom,
      minutesFrom: this.timeGroup.minutesFrom,
      hoursTo: this.timeGroup.hoursTo,
      minutesTo: this.timeGroup.minutesTo,
    });
  }

  private clearTimeGroup() {
    this.timeGroup = {
      hoursFrom: undefined,
      minutesFrom: undefined,
      hoursTo: undefined,
      minutesTo: undefined,
    };
  }
}
